"use client";

import { useTheme } from "next-themes";
import { Toaster as SonnerToaster } from "sonner";

function Toaster() {
  const { theme = "light" } = useTheme();

  return (
    <SonnerToaster
      theme={(theme as "light" | "dark" | "system") ?? "light"}
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "bg-card text-foreground border-border/80 shadow-[var(--shadow-soft)]",
          title: "font-medium",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-foreground",
        },
      }}
    />
  );
}

export { Toaster };
